import React, { useEffect, useState } from "react"
import {
  makeRem,
  Form,
  FormInput,
  FormSubmit,
  Spinner,
  Standalone,
  Text,
  Title,
} from "@thedgbrt/logology-ui-components"
import { FormError } from "../../common/Form"
import { trackAmplitude } from "../../../helpers/amplitude"
import { trackSegmentEvent } from "../../../helpers/segment"
import Auth from "@aws-amplify/auth"
import { navigate } from "gatsby"

const SendVerificationCode = ({ email, pw, onCancel, sendRightAway }) => {
  const [error, setError] = useState({ exists: false, message: "" })
  const [loading, setLoading] = useState(false)
  const [input, setInput] = useState("")

  useEffect(() => {
    if (sendRightAway === true) resendCode()
  }, []) // eslint-disable-line

  const resendCode = () => {
    setError({ exists: false, message: "" })
    setLoading(true)

    Auth.resendSignUp(email)
      .then(() => {
        setError({ exists: true, message: "We've sent you a new code." })
        setLoading(false)
      })
      .catch(err => {
        setError({ exists: true, message: err.message })
        setLoading(false)
      })
  }

  const handleSubmit = () => {
    setLoading(true)
    Auth.confirmSignUp(email, input)
      .then(res =>
        Auth.signIn({
          username: email,
          password: pw,
        })
      )
      .then(() => {
        trackSegmentEvent("track", "Submit verification code")
        trackAmplitude("Submit verification code")
        navigate("/myaccount/proposals/")
      })
      .catch(err => {
        setLoading(false)
        if (err.code === "CodeMismatchException")
          setError({ exists: true, message: "Wrong code" })
        else navigate("/signin/")
        console.log(err)
      })
  }

  return (
    <>
      {loading ? (
        <Spinner position="left" standalone />
      ) : (
        <>
          <FormError error={error} withMargin />
          <Title
            level={3}
            style={{ marginBottom: makeRem(0) }}
            subtitle={`We sent a verification code to ${email}.`}
            standalone
          >
            Verify your email address
          </Title>

          <Standalone>
            <Form left>
              <FormInput
                placeholder="Enter the verification code"
                type="number"
                name="verificationCode"
                value={input}
                onChange={e => setInput(e.target.value)}
              />
              <FormSubmit text="continue →" onClick={handleSubmit} />
            </Form>
          </Standalone>

          <Text
            className="small-text"
            standalone
            style={{ marginBottom: makeRem(18), marginTop: makeRem(36) }}
          >
            <em>
              {/* @forgiveme, #a doesn't do anything, it's just to fix empty href warning, true fix would be a button component styled like an inline link. */}
              <a href="#a" onClick={resendCode}>
                Resend code
              </a>
              &nbsp;&nbsp;&nbsp;
              <a href="#a" onClick={onCancel}>
                Use a different email address
              </a>
            </em>
          </Text>
        </>
      )}
    </>
  )
}

export default SendVerificationCode
